/**
 * Offer Configure permission constants and helpers.
 *
 * Backend should issue these abilities in userData.abilities on login:
 * - { action: 'read', subject: 'offer_configure' } — view configs
 * - { action: 'manage', subject: 'offer_configure' } — create/edit/delete
 */

export const OFFER_CONFIGURE_PERMISSIONS = {
  MODULE: 'offer_configure',
}

export const OFFER_CONFIGURE_ACTIONS = {
  READ: 'read',
  MANAGE: 'manage',
}

function hasPermission(canFn, action, subject) {
  if (typeof canFn !== 'function') return false
  return !!canFn(action, subject)
}

export function canViewOfferConfigure(canFn) {
  return (
    hasPermission(canFn, OFFER_CONFIGURE_ACTIONS.READ, OFFER_CONFIGURE_PERMISSIONS.MODULE)
    || hasPermission(canFn, OFFER_CONFIGURE_ACTIONS.MANAGE, OFFER_CONFIGURE_PERMISSIONS.MODULE)
    || hasPermission(canFn, 'manage', 'all')
  )
}

export function canManageOfferConfigure(canFn) {
  return (
    hasPermission(canFn, OFFER_CONFIGURE_ACTIONS.MANAGE, OFFER_CONFIGURE_PERMISSIONS.MODULE)
    || hasPermission(canFn, 'manage', 'all')
  )
}

export default {
  OFFER_CONFIGURE_PERMISSIONS,
  OFFER_CONFIGURE_ACTIONS,
  canViewOfferConfigure,
  canManageOfferConfigure,
}
